import { Stack } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledDatePicker, ControlledSelector } from 'components/common/controller-wrapper'
import {
  ALLOCATION_STABILITY_EARLIEST_DATE,
  ALLOCATION_STABILITY_TIME_PERIODS,
} from 'components/reports/Metrics/constants/AllocationStability'

import { XeroCodeMultipleAutocomplete } from '../components/XeroCodeMultipleAutocomplete'
import { VEHICLE_TYPES } from '../constants/vehicleTypes'
import { AllocationStabilityFilterValues } from './AllocationStabilityFilterCriteria'

export const AllocationStabilityFiltersForm = () => {
  const { control } = useFormContext<AllocationStabilityFilterValues>()
  const [period, customStart, customEnd] = useWatch({
    control,
    name: ['period', 'customStart', 'customEnd'],
  })
  const isCustom = period === 'custom'

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      useFlexGap
      flexWrap='wrap'
      alignItems={{ xs: 'stretch', sm: 'flex-end' }}>
      <ControlledSelector
        control={control}
        name='period'
        label='Time period'
        options={ALLOCATION_STABILITY_TIME_PERIODS}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 160 }}
      />

      {isCustom && (
        <>
          <ControlledDatePicker
            control={control}
            name='customStart'
            label='From'
            minDate={ALLOCATION_STABILITY_EARLIEST_DATE}
            maxDate={customEnd ?? new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
          <ControlledDatePicker
            control={control}
            name='customEnd'
            label='To'
            minDate={customStart ?? ALLOCATION_STABILITY_EARLIEST_DATE}
            maxDate={new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
        </>
      )}

      <XeroCodeMultipleAutocomplete
        control={control}
        name='selectedServiceCodes'
        limitTags={3}
        size='small'
        sx={{ minWidth: 220 }}
      />

      <ControlledSelector
        control={control}
        name='vehicleType'
        label='Vehicle type'
        options={VEHICLE_TYPES}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 180 }}
      />
    </Stack>
  )
}
